<style scoped lang="less">
  .login-modal-x {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 40px;
  }

  .login-content-x {
    width: 100%;
    padding: 20px;
    background-color: #fff;
    border-radius: 10px;
    background-position: top center;
    background-size: 100% auto;
    background-repeat: no-repeat;
    position: relative;
    z-index: 2;
  }

  .login-title {
    color: #333;
    text-align: center;
    font-size: 20px;
    font-weight: bold;
  }

  .form-x {
    margin: 20px 0;
  }

  .form-item-x {
    border: 1px solid #f5f5f5;
    border-radius: 10px;

    & + & {
      margin-top: 10px;
    }
  }

  .field-btn {
    color: #333;
    text-align: right;
    font-size: 14px;
    font-weight: 400;
  }

  .xy-box {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 20px;

    .p-xy {
      font-size: 10px;
      color: #5e5e5e;

      .xy {
        color: #4782ed;
      }
    }
  }

  .close-icon {
    width: 30px;
    height: 30px;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 50%;
    border: 2px solid;
    color: #adadad;
    font-size: 16px;
    margin-top: 20px;
    position: relative;

    &::before {
      content: '';
      position: absolute;
      width: 2px;
      background-color: #adadad;
      height: 25px;
      top: 0;
      left: 50%;
      transform: translate(-50%, -100%);
    }
  }
</style>

<template>
  <van-overlay :show="visible" :z-index="999">
    <base-dialog
      v-if="loginDialogProps.dialogState === 'confirm'"
      title="温馨提示"
      message="您当前还未登录，是否登录？"
      cancel-btn-text="我再想想"
      confirm-btn-text="立即登录"
      @confirm="confirmToLogin"
      @cancel="cancelToLogin"
    />
    <login-dialog
      v-else-if="loginDialogProps.dialogState === 'login'"
      ref="loginDialogRef"
      :agreement-list="agreements"
      @view-agreement="viewAgreement"
      @cancel-model="cancelModel"
      @confirm="toLogin"
    />
    <one-click-login-dialog
      v-else-if="loginDialogProps.dialogState === 'one-click-login'"
      ref="loginDialogRef"
      :agreement-list="agreements"
      @view-agreement="viewAgreement"
      @cancel-model="cancelModel"
      @confirm="toLogin"
    />
  </van-overlay>
  <AgreementModal v-model:visible="showAgreement" :url="curAgreement.detailUrl" />
</template>

<script lang="ts" setup>
  import AgreementModal from '../agreementModal/index.vue';
  import { useAgreement } from '@/hooks';
  import { buriedPointHook } from '@/hooks/buriedPoint';
  import dayjs from 'dayjs';
  import BaseDialog from '@/components/dialog/baseDialog.vue';
  import LoginDialog from '@/components/dialog/loginDialog.vue';
  import OneClickLoginDialog from '@/components/dialog/oneClickLoginDialog.vue';
  import { useLoginDialog } from '@/store';

  defineOptions({ name: 'LoginModal' });
  const loginDialogProps = useLoginDialog();
  const loginDialogRef = ref();
  const visible = computed(() => !!loginDialogProps.dialogState);
  const emits = defineEmits<{ (e: 'afterLogin'): void }>();
  const {
    agreements,
    showAgreement,
    curAgreement,
    getAgreements,
    viewAgreement,
    saveSignAgreement,
  } = useAgreement({ signingScene: 'H5_LOGIN', platform: 'H5' });

  const { buriedOperationFn } = buriedPointHook();
  const { VITE_IMG_BASE_URL } = import.meta.env;

  // 确认弹窗点击确认
  const confirmToLogin = () => loginDialogProps.setLoginState('login');
  // 确认弹窗点击取消
  const cancelToLogin = () => {
    loginDialogProps.executeEvent('cancelLogin');
    closeModal();
  };

  const closeModal = () => loginDialogProps.closeDialog();
  const cancelModel = () => {
    // visible.value = false;
    closeModal();
  };

  const toLogin = () => {
    saveSignAgreement({ signingScene: 3 });
    // 埋点
    closeModal();
  };

  watch(
    visible,
    (newVal) => {
      loginDialogRef.value &&
        loginDialogRef.value.initData &&
        loginDialogRef.value.initData(newVal);
      newVal && getAgreements();
    },
    { immediate: true }
  );
</script>
